var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.641 9.17355C15.2682 6.2884 14.0128 3.128 11.2864 1.3811C7.82876 -0.834319 3.3057 0.0625257 1.19776 3.3815C-0.910178 6.70047 0.186686 11.1982 3.6443 13.4136C6.37069 15.1605 9.75321 14.9719 12.0936 13.1844L16.6376 16.0959L14.0902 20.1067L18.2686 22.784L20.816 18.7731L22.9052 20.1118L25.4525 16.1009L14.641 9.17355ZM6.19165 9.40278C5.0426 8.66654 4.67562 7.16172 5.37614 6.05874C6.07667 4.95576 7.58996 4.6557 8.73901 5.39194C9.88807 6.12818 10.255 7.633 9.55452 8.73599C8.854 9.83897 7.34071 10.139 6.19165 9.40278Z",
    fill: "#8C8E86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyGray);
export default __webpack_public_path__ + "static/media/keyGray.bb7e5db767c90f960ff08afa07e84dd8.svg";
export { ForwardRef as ReactComponent };